<template>
	<div class="contractAdd">
		<el-card>
			<div class="jump-btn">
				<el-button type="primary" @click="back">返回合同管理</el-button>
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="wid100"
				:label-width="require('@/config/enum').c_ws6" :label-suffix="require('@/config/enum').c_colon">
				<el-form-item label="合同编号" prop="contractNum">
					<el-input v-model="ruleForm.contractNum" placeholder="请输入合同编号" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="合同名称" prop="contractName">
					<el-input v-model="ruleForm.contractName" placeholder="请输入合同名称" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="合同甲方" prop="contractNail">
					<el-input v-model="ruleForm.contractNail" placeholder="请输入合同甲方" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="合同乙方" prop="contractSupplier">
					<el-select filterable v-model="ruleForm.contractSupplier" placeholder="请选择合同乙方">
						<el-option v-for="(item, index) in supplierList" :key="index" :value="item.id" :label="item.supplierName">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="合同保证金" prop="contractBondPrice">
					<el-input v-model="ruleForm.contractBondPrice" placeholder="请输入合同保证金" class="item-input" maxlength="24"
						oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
				</el-form-item>
				<el-form-item label="合同金额" prop="contractPrice">
					<el-input v-model="ruleForm.contractPrice" placeholder="请输入合同金额" class="item-input" maxlength="24"
						oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
				</el-form-item>
				<el-form-item label="付款周期" prop="contractPaymentPeriod">
					<el-select v-model="ruleForm.contractPaymentPeriod" placeholder="请选择付款周期">
						<el-option v-for="(item, index) in contractPaymentPeriodList" :key="index" :value="item.id"
							:label="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="收款方式" prop="contractPaymentType">
					<el-input v-model="ruleForm.contractPaymentType" placeholder="请输入收款方式" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="递增比例" prop="contractAddScale">
					<el-input v-model="ruleForm.contractAddScale" placeholder="请输入递增比例" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="开始递增日期" prop="startAddDate">
					<el-date-picker class="authority" v-model="ruleForm.startAddDate" type="date" value-format='timestamp'
						placeholder="请选择开始递增日期">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="合同开始日期" prop="startDate">
					<el-date-picker class="authority" v-model="ruleForm.startDate" type="date" value-format='timestamp'
						:placeholder="$t('lang.venue.tip_select_startDate')">
					</el-date-picker>
				</el-form-item>
				<el-form-item label="合同截止日期" prop="endDate">
					<el-date-picker class="authority" v-model="ruleForm.endDate" type="date" value-format='timestamp'
						:placeholder="$t('lang.venue.tip_select_endDate')">
					</el-date-picker>
				</el-form-item>
				<!-- 合同责任人 -->
				<el-form-item label="合同责任人" prop="contractStaffId">
					<el-select v-model="ruleForm.contractStaffId" placeholder="请选择合同责任人" filterable style="width: 443px;">
						<el-option v-for="(item, index) in contractStaffsList" :key="index" :value="item.id" :label="item.idNo">
						</el-option>
					</el-select>
				</el-form-item>
				<!-- 付款计划 -->
				<el-form-item label="付款计划">
					<div style="display: flex;align-items: center;margin-bottom: 10px;" v-for="(item, index) in ruleForm.payPlanList" :key="index">
						<el-date-picker class="authority" :disabled="payPlanIsEdit" :picker-options="pickerOptions" v-model="ruleForm.payPlanList[index].payPlanDate" type="date" value-format='timestamp'
							placeholder="请选择付款日期" style="margin-right: 20px;">
						</el-date-picker>
						<el-input :disabled="payPlanIsEdit" v-model="ruleForm.payPlanList[index].payPlanPrice" placeholder="请输入付款金额" class="item-input" maxlength="24"
							oninput="value=value.replace(/[^0-9.]/g,'')" style="width: 200px;margin-right: 20px;"></el-input>
						<i class="el-icon-remove" style="font-size: 24px;color: red;margin-left: 10px;" v-if="!payPlanIsEdit" @click="reduce(index)"></i>
					</div>
					<el-button type="primary" @click="addPayPlan()" :disabled="payPlanIsEdit">添加付款计划</el-button>
					<el-tooltip class="item" effect="light" style="margin-left:20px" placement="right">
						<div slot="content">
							添加付款计划，到付款日期后，会自动生成一条工单，并指派给合同责任人，提醒合同责任人去跟进合同相关事宜。<br>
							<br>
							<span style="color: red;">注意：付款计划保存后，不可修改，不可删除；请谨慎操作。</span><br>
						</div>
            <el-button class="noStyle"><i class="el-icon-warning-outline tipIcon"></i></el-button>
          </el-tooltip>
				</el-form-item>
				<el-form-item label="合同状态" prop="contractState">
					<el-select v-model="ruleForm.contractState" placeholder="请选择合同状态" disabled>
						<el-option v-for="(item, index) in contractStateList" :key="index" :value="item.id" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="归档人" prop="contractFilePeople">
					<el-input v-model="ruleForm.contractFilePeople" placeholder="请输入归档人" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="归档状态" prop="contractFileState">
					<el-select v-model="ruleForm.contractFileState" placeholder="请选择归档状态">
						<el-option v-for="(item, index) in contractFileStateList" :key="index" :value="item.id" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="甲方责任人" prop="contractNailName">
					<el-input v-model="ruleForm.contractNailName" placeholder="请输入甲方责任人" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="甲方责任人电话" prop="contractNailPhone">
					<el-input v-model="ruleForm.contractNailPhone" placeholder="请输入甲方责任人电话" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="乙方责任人" prop="contractSupplierName">
					<el-input v-model="ruleForm.contractSupplierName" placeholder="请输入乙方责任人" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="乙方责任人电话" prop="contractSupplierPhone">
					<el-input v-model="ruleForm.contractSupplierPhone" placeholder="请输入乙方责任人电话" class="item-input"></el-input>
				</el-form-item>
				<!-- 合同图片 -->
				<el-form-item label="附件">
					<upload-morefile ref="uploading" :fileList='filesList' upTypes='1' :clears='clears' @outputFile="getFile"
						@removeFile='removeFile'></upload-morefile>
				</el-form-item>
				<el-form-item label="合同变更类型" prop="contractChangeType" v-if="!isAdd">
					<el-select v-model="ruleForm.contractChangeType" placeholder="请选择合同变更类型">
						<el-option v-for="(item, index) in contractChangeTypeList" :key="index" :value="item.id" :label="item.name">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="变更原因" prop="contractChangeReason" v-if="!isAdd">
					<el-input v-model="ruleForm.contractChangeReason" placeholder="请输入变更原因" class="item-input"></el-input>
				</el-form-item>
				<el-form-item label="变更附件" v-if="!isAdd">
					<upload-morefile ref="uploading" :fileList='filesList1' upTypes='1' :clears='clears' @outputFile="getFile1"
						@removeFile='removeFile1'></upload-morefile>
				</el-form-item>
				<el-button class="detailbtn" type="primary" @click="save()" :disabled="isDisabled">
					{{$t('lang.btn_save')}}</el-button>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	import uploadmoreFile from '../../components/upload_morefile.vue'
	export default {
		data() {
			const validateMoney = (rule, value, callback) => {
				if (!value) {
					callback()
				} else if (value.toString().indexOf('.') != -1 && value.toString().split('.').length > 2) {
					callback(new Error('请输入正确格式的金额')) // 防止输入多个小数点
				} else if (value.toString().indexOf('.') != -1 && value.toString().split('.')[1].length > 2) {
					callback(new Error('请输入正确的小数位数')) // 小数点后两位
				} else {
					callback()
				}
			}
			return {
				clears: false,
				accept: '.jpg, .jpeg, .png',
				zero: 0, // 值为0的变量
				ruleForm: {
					id: '',
					contractNum: '',
					contractName: '',
					contractNail: '',
					contractSupplier: '',
					contractBondPrice: '',
					contractPrice: '',
					contractPaymentPeriod: '',
					contractPaymentType: '',
					contractAddScale: '',
					startAddDate: '',
					startDate: '',
					endDate: '',
					contractFilePeople: '',
					contractState: '1',
					contractFileState: '2',
					contractNailName: '',
					contractNailPhone: '',
					contractSupplierName: '',
					contractSupplierPhone: '',
					contractChangeType: '',
					contractChangeReason: '',
					contractStaffId: '',
					payPlanList: [],
				},
				fileList: [], // 图片list
				filesList: [], // 图片list
				fileList1: [], // 图片list
				filesList1: [], // 图片list
				rules: {
					contractNum: [{
						required: true,
						message: '请输入合同编号',
						trigger: 'blur'
					}],
					contractName: [{
						required: true,
						message: '请输入合同名称',
						trigger: 'blur'
					}],
					contractNail: [{
						required: true,
						message: '请输入合同甲方',
						trigger: 'blur'
					}],
					contractSupplier: [{
						required: true,
						message: '请选择合同乙方',
						trigger: 'blur'
					}],
					contractBondPrice: [{
						required: true,
						validator: validateMoney,
						trigger: 'blur'
					}],
					contractPrice: [{
						required: true,
						validator: validateMoney,
						trigger: 'blur'
					}],
					contractPaymentPeriod: [{
						required: true,
						message: '请选择付款周期',
						trigger: 'change'
					}],
					startDate: [{
						required: true,
						message: '请选择合同生效日期',
						trigger: 'change'
					}],
					endDate: [{
						required: true,
						message: '请选择合同截止日期',
						trigger: 'change'
					}],
					contractFileState: [{
						required: true,
						message: '请选择合同归档状态',
						trigger: 'change'
					}],
					contractStaffId: [{
						required: true,
						message: '请选择合同责任人',
						trigger: 'change'
					}],
					// contractNailName: [{
					// 	required: true,
					// 	message: '请输入合同甲方责任人',
					// 	trigger: 'blur'
					// }],
					// contractNailPhone: [{
					// 	required: true,
					// 	message: '请输入合同甲方责任人电话',
					// 	trigger: 'blur'
					// }],
					// contractSupplierName: [{
					// 	required: true,
					// 	message: '请输入合同乙方责任人',
					// 	trigger: 'blur'
					// }],
					// contractSupplierPhone: [{
					// 	required: true,
					// 	message: '请输入合同乙方责任人电话',
					// 	trigger: 'blur'
					// }],
				},
				supplierList: [], // 供应商列表
				contractPaymentPeriodList: [{
						id: '1',
						name: '年付'
					},
					{
						id: '2',
						name: '半年付'
					},
					{
						id: '3',
						name: '季度付'
					}
				], // 付款周期列表
				contractStateList: [{
						id: '1',
						name: '正常'
					},
					{
						id: '2',
						name: '已过期'
					},
					{
						id: '3',
						name: '已关闭'
					}
				], // 合同状态
				contractFileStateList: [{
						id: '1',
						name: '已归档'
					},
					{
						id: '2',
						name: '未归档'
					}
				], // 归档状态
				contractStaffsList: [], // 合同责任人列表
				contractChangeTypeList: [{
						id: '1',
						name: '调整合同基本信息'
					},
					{
						id: '2',
						name: '调整资源'
					},
					{
						id: '3',
						name: '调整收款计划'
					},
					{
						id: '4',
						name: '终止合作'
					}
				], // 合同变更类型列表
				saveData: '',
				saveUrls: '',
				isDisabled: true, // 保存的可点击,
				payPlanIsEdit: false, // 付款计划是否可修改禁用状态
				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now()
					}
				}, // 付款计划日期只能选择当前日期之后的日期 
			}
		},
		components: {
			'upload-morefile': uploadmoreFile
		},
		destroyed() {
			window.localStorage.setItem('contractForm', JSON.stringify(this.ruleForm))
		},
		created() {
			this.isAdd = this.$route.query.flag
			if (window.localStorage.getItem('contractForm')) {
				this.ruleForm = JSON.parse(window.localStorage.getItem('contractForm'))
			} else {
				if (!this.$route.query.flag) {
					console.log('编辑')
					this.getData()
				} else {
					console.log('新增')
				}
			}
			// 获取供应商列表
			this.getSupplierList()
			this.getContractStaffsList()
		},
		watch: {
			ruleForm: {
				handler(newVal, oldVal) {
					if (newVal.contractChangeType == 4) {
						this.ruleForm.contractState = '3'
					} else {
						var nowDate = new Date().getTime()
						if (newVal.endDate < nowDate) {
							this.ruleForm.contractState = '2'
						} else {
							this.ruleForm.contractState = '1'
						}
					}
					// ruleForm数据变化时 会调用此方法
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.saveData) {
						// 没变
						this.isDisabled = true
					} else {
						// 变了
						this.isDisabled = false
					}
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			// 返回
			back() {
				this.$router.push({
					name: 'contractList'
				})
			},
			// 获取供应商列表
			getSupplierList() {
				let loading = this.$loading()
				let url = `/venueSupplier?gardenId=${this.$store.getters.gardenId}&pageSize=999&pageNo=1`
				this.$get(url)
					.then(res => {
							loading.close()
							console.log(res)
							this.supplierList = res.list
						},
						error => {
							loading.close()
							this.$message.error(error)
						})
			},
			// 获取合同责任人列表
			getContractStaffsList() {
				let loading = this.$loading()
				let url = `/staffs?gardenId=${this.$store.getters.gardenId}&pageSize=9999&pageNo=1`
				this.$get(url)
					.then(res => {
							loading.close()
							console.log(res)
							this.contractStaffsList = res.list
						},
						error => {
							loading.close()
							this.$message.error(error)
						})
			},
			// 添加付款计划
			addPayPlan() {
				this.ruleForm.payPlanList.push({ 'payPlanDate': '', 'payPlanPrice': '', 'contractStaffId': '' })
			},
			// 删减付款计划
			reduce(index) {
				let target = this.ruleForm.payPlanList[index]
				this.ruleForm.payPlanList = this.ruleForm.payPlanList.filter(item => item !== target)
			},
			// 获取详情数据
			getData() {
				console.log('object', this.$route.query.object)
				this.ruleForm.id = this.$route.query.object.id
				this.ruleForm.contractNum = this.$route.query.object.contractNum
				this.ruleForm.contractName = this.$route.query.object.contractName
				this.ruleForm.contractNail = this.$route.query.object.contractNail
				this.ruleForm.contractSupplier = this.$route.query.object.contractSupplier - 0
				this.ruleForm.contractBondPrice = this.$route.query.object.contractBondPrice
				this.ruleForm.contractPrice = this.$route.query.object.contractPrice
				this.ruleForm.contractPaymentPeriod = this.$route.query.object.contractPaymentPeriod
				this.ruleForm.contractPaymentType = this.$route.query.object.contractPaymentType
				this.ruleForm.contractAddScale = this.$route.query.object.contractAddScale
				this.ruleForm.startAddDate = this.$route.query.object.startAddDate
				this.ruleForm.startDate = this.$route.query.object.startDate
				this.ruleForm.endDate = this.$route.query.object.endDate
				this.ruleForm.contractFilePeople = this.$route.query.object.contractFilePeople
				this.ruleForm.contractState = this.$route.query.object.contractState
				this.ruleForm.contractFileState = this.$route.query.object.contractFileState
				this.ruleForm.contractNailName = this.$route.query.object.contractNailName
				this.ruleForm.contractNailPhone = this.$route.query.object.contractNailPhone
				this.ruleForm.contractSupplierName = this.$route.query.object.contractSupplierName
				this.ruleForm.contractSupplierPhone = this.$route.query.object.contractSupplierPhone
				this.ruleForm.contractChangeType = this.$route.query.object.contractChangeType
				this.ruleForm.contractChangeReason = this.$route.query.object.contractChangeReason
				this.ruleForm.contractStaffId = this.$route.query.object.contractStaffId
				this.ruleForm.payPlanList = this.$route.query.object.hirePurchaseList
				if (this.ruleForm.payPlanList.length > 0) {
					this.payPlanIsEdit = true
				}
				if (this.$route.query.object.photoUrlsList) {
					var list = this.$route.query.object.photoUrlsList
					var arr = []
					for (let i = 0; i < list.length; i++) {
						arr.push({
							name: '',
							url: list[i]
						})

						this.filesList = arr
						this.fileList = arr
					}
					console.log('res : ' + JSON.stringify(this.filesList))
				} else {
					this.filesList = []
					this.fileList = []
				}
				if (this.$route.query.object.photoUrlsList1) {
					var list1 = this.$route.query.object.photoUrlsList1
					var arr1 = []
					for (let i = 0; i < list1.length; i++) {
						arr1.push({
							name: '',
							url: list1[i]
						})

						this.filesList1 = arr1
						this.fileList1 = arr1
					}
					console.log('res : ' + JSON.stringify(this.filesList1))
				} else {
					this.filesList1 = []
					this.fileList1 = []
				}

				// 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
				this.saveData = JSON.stringify(this.ruleForm)
				console.log(this.ruleForm)
			},
			// 保存
			save() {
				this.$refs['ruleForm'].validate(valid => {
					if (valid) {
						for (let i = 0; i < this.ruleForm.payPlanList.length; i++) {
							this.$set(this.ruleForm.payPlanList[i], 'contractStaffId', this.ruleForm.contractStaffId)
						}
						console.log(this.ruleForm.payPlanList)
						let startDate = this.ruleForm.startDate
						let endDate = this.ruleForm.endDate
						let arr = this.ruleForm.payPlanList
						let payAllPrice = 0
						if (arr.length != 0) {
							for (let i = 0; i < arr.length; i++) {
								if (!arr[i].payPlanDate || !arr[i].payPlanPrice) {
									this.$message.error('【付款计划】请选择或清除您的付款计划')
									return
								} else {
									payAllPrice += arr[i].payPlanPrice - 0
									if (arr[i].payPlanDate < startDate) {
										this.$message.error('【付款计划】付款日期不能早于合同开始日期')
										return
									}
									if (arr[i].payPlanDate > endDate) {
										this.$message.error('【付款计划】付款日期不能晚于合同截止日期')
										return
									}
									if (payAllPrice > this.ruleForm.contractPrice) {
										this.$message.error('【付款计划】付款计划总金额不能大于合同金额')
										return
									}
								}
							}
						}
						console.log(payAllPrice)
						this.filesList = []
						this.filesList1 = []
						if (this.fileList.length > 0) {
							for (let i = 0; i < this.fileList.length; i++) {
								this.filesList.push(this.fileList[i].url)
							}
						}
						if (this.fileList1.length > 0) {
							for (let i = 0; i < this.fileList1.length; i++) {
								this.filesList1.push(this.fileList1[i].url)
							}
						}
						// 上传图片
						if (this.ruleForm.startDate && this.ruleForm.endDate) {
							if (this.ruleForm.startDate > this.ruleForm.endDate) {
								this.$message.error('开始日期不能大于截止日期')
								return
							}
						}
						if (this.isAdd) {
							let params = {
								gardenId: this.$store.getters.gardenId,
								contractNum: this.ruleForm.contractNum,
								contractName: this.ruleForm.contractName,
								contractNail: this.ruleForm.contractNail,
								contractSupplier: this.ruleForm.contractSupplier,
								contractBondPrice: this.ruleForm.contractBondPrice,
								contractPrice: this.ruleForm.contractPrice,
								contractPaymentPeriod: this.ruleForm.contractPaymentPeriod,
								contractPaymentType: this.ruleForm.contractPaymentType,
								contractAddScale: this.ruleForm.contractAddScale,
								startAddDate: this.ruleForm.startAddDate,
								startDate: this.ruleForm.startDate,
								endDate: this.ruleForm.endDate,
								contractFilePeople: this.ruleForm.contractFilePeople,
								contractState: this.ruleForm.contractState,
								contractFileState: this.ruleForm.contractFileState,
								contractNailName: this.ruleForm.contractNailName,
								contractNailPhone: this.ruleForm.contractNailPhone,
								contractSupplierName: this.ruleForm.contractSupplierName,
								contractSupplierPhone: this.ruleForm.contractSupplierPhone,
								filesList: this.filesList.length > 0 ? this.filesList.toString() : [],
								contractStaffId: this.ruleForm.contractStaffId,
								payPlanList: this.ruleForm.payPlanList.length > 0 ? JSON.stringify(this.ruleForm.payPlanList) : '',
							}
							console.log(params)
							console.log(typeof (params.payPlanList))
							let loading = this.$loading()
							this.$post(`/venueContract`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										var index = this.$keepAlive.indexOf('/manage/main.contractList')
										if (index > -1) {
											this.$keepAlive.splice(index, 1)
										}
										this.back()
									} else if (res && res.errCode != 0) {
										this.$message.error(res.errMsg)
									}
								},
								error => {
									loading.close()
									if (error == '重复数据') {
										this.$message.error('合同编号已存在，请修改合同编号')
									} else {
										this.$message.error(error)
									}
								}
							)
						} else {
							// if (!this.ruleForm.contractChangeType) {
							// 	this.$message.error('请选择合同变更类型')
							// 	return
							// }
							// if (!this.ruleForm.contractChangeReason) {
							// 	this.$message.error('请输入合同变更原因')
							// 	return
							// }

							let loading = this.$loading()
							let params = {
								gardenId: this.$store.getters.gardenId,
								contractNum: this.ruleForm.contractNum,
								contractName: this.ruleForm.contractName,
								contractNail: this.ruleForm.contractNail,
								contractSupplier: this.ruleForm.contractSupplier,
								contractBondPrice: this.ruleForm.contractBondPrice,
								contractPrice: this.ruleForm.contractPrice,
								contractPaymentPeriod: this.ruleForm.contractPaymentPeriod,
								contractPaymentType: this.ruleForm.contractPaymentType,
								contractAddScale: this.ruleForm.contractAddScale,
								startAddDate: this.ruleForm.startAddDate,
								startDate: this.ruleForm.startDate,
								endDate: this.ruleForm.endDate,
								contractFilePeople: this.ruleForm.contractFilePeople,
								contractState: this.ruleForm.contractState,
								contractFileState: this.ruleForm.contractFileState,
								contractNailName: this.ruleForm.contractNailName,
								contractNailPhone: this.ruleForm.contractNailPhone,
								contractSupplierName: this.ruleForm.contractSupplierName,
								contractSupplierPhone: this.ruleForm.contractSupplierPhone,
								contractChangeType: this.ruleForm.contractChangeType,
								contractChangeReason: this.ruleForm.contractChangeReason,
								filesList: this.filesList.length > 0 ? this.filesList.toString() : '',
								filesList1: this.filesList1.length > 0 ? this.filesList1.toString() : '',
								contractStaffId: this.ruleForm.contractStaffId,
								payPlanList: JSON.stringify(this.ruleForm.payPlanList),
							}
							console.log(params)
							this.$patch(`/venueContract/` + this.ruleForm.id, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										var index = this.$keepAlive.indexOf('/manage/main.contractList')
										if (index > -1) {
											this.$keepAlive.splice(index, 1)
										}
										this.back()
									} else if (res && res.errCode != 0) {
										this.$message.error(res.errMsg)
									}
								},
								error => {
									loading.close()
									if (error == '重复数据') {
										this.$message.error('合同编号已存在，请修改合同编号')
									} else {
										this.$message.error(error)
									}
								}
							)
						}
					}
				})
			},
			// 获取组件值
			getFile(e) {
				console.log(e)
				var that = this
				setTimeout(() => {
					that.fileList.push({
						name: '',
						url: e
					})
					console.log(that.fileList)
					that.isDisabled = false
				}, 1)
			},
			// 移除图片
			removeFile(e) {
				this.isDisabled = false
				let list1 = []
				for (let i = 0; i < this.fileList.length; i++) {
					if (this.fileList[i].url === e) {

					} else {
						list1.push(this.fileList[i])
					}
				}
				this.fileList = list1
			},
			// 获取组件值
			getFile1(e) {
				console.log(e)
				var that = this
				setTimeout(() => {
					that.fileList1.push({
						name: '',
						url: e
					})
					console.log(that.fileList1)
					that.isDisabled = false
				}, 1)
			},
			// 移除图片
			removeFile1(e) {
				this.isDisabled = false
				let list1 = []
				for (let i = 0; i < this.fileList1.length; i++) {
					if (this.fileList1[i].url === e) {} else {
						list1.push(this.fileList1[i])
					}
				}
				this.fileList1 = list1
				console.log(this.fileList1)
			}
		}
	}
</script>

<style lang="scss">
	.contractAdd {
		.item-input {
			width: 30%;
		}
	}
</style>